const exercise = {
  exercise: "Exercise",
  create: "Create an exercise",
  edit: "Edit an exercise",
  createExerciseInstruction:
    'Enter the question, select the part(s) of the text that correspond to the answer, and click the "Answer" button to submit. Please enter the number of questions matching the selected grading scale.',
  doExercises: "Practice",
  exercises: "Exercises",
};

export default exercise;
